import React, { Component } from 'react';
import './index.scss';
import { Helmet } from 'react-helmet';
import _ from 'lodash';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { withTranslation } from 'react-i18next';
import TopDrugs from '../TopDrugs/index.jsx';
import RxCardSendCoupon from '../RxCard/RxCardSendCoupon';
import {
  RX_CARD_VIEW,
  PRESC_DESC_URL,
  PRESC_DESC_URL_ES,
  RXSENSE,
  NAVITUS
} from '../../constants/defaults';
import { newFetchCouponData } from '../../services/Api/Coupon/CouponService';
import DiscountSavingsSection from './DiscountSavingSection';
import PharmacyList from '../common/PharmacyList';
import { getStoreLdJson } from './ldJosn';
import Image from '../common/Image.jsx';
import Breadcrumb from '../DrugDetails/Breadcrumb';
import NotFound from '../NotFound/index.jsx';
import SkipTo from '../common/Tag/SkipTo';

const { API } = require('../../config/' + process.env.REACT_APP_ENV);

class DiscountPage extends Component {
  constructor(props) {
    super(props);

    let data;
    if (
      typeof window !== 'undefined' &&
      typeof __INITIAL_DATA__ !== 'undefined'
    ) {
      data = window.__INITIAL_DATA__;
      delete window.__INITIAL_DATA__;
    } else {
      data = this.props.staticContext.data;
    }

    // get pharmacyname from backend

    this.state = {
      data,
      cardImage: null,
      pharmacyName: data.name,
      selectedPharmacy: {
        PartnerUser: data.partnerId,
        PartnerPassword: data.partnerPassword,
        PharmacyName: data.name
      }
    };
  }

  toggleSearch() {
    const clickEvent = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    });
    const myButton = document.getElementById('mobile-search-icon');
    myButton.dispatchEvent(clickEvent);
  }

  componentDidMount() {
    let intervalId = setInterval(() => {
      const prospectId = _.getCookie('prospect-id');
      if (prospectId && this.state.pharmacyName) {
        clearInterval(intervalId);
        this.fetchCardDetail(this.state.pharmacyName);
      }
    }, 200);
  }

  async fetchCardDetail(pharmacyName) {
    if (_.isEqual(pharmacyName, 'invalid')) return;
    // set pharmacy name here.
    let selectedPharmacy = {
      PartnerUser: this.state.selectedPharmacy.PartnerUser,
      PartnerPassword: this.state.selectedPharmacy.PartnerPassword,
      PharmacyName: this.state.selectedPharmacy.PharmacyName
    };
    const utmzCookie = _.getCookie('_utmz_custom');
    const utmzCookies = utmzCookie.split('|');
    const source = utmzCookies[2].split('=')[1] || null,
      medium = utmzCookies[1].split('=')[1] || null,
      cgn = utmzCookies[0].split('=')[1] || null;
    let utmParams = {
      src: source,
      med: medium,
      cgn: cgn
    };
    try {
      const fetchCouponResp = await newFetchCouponData(
        selectedPharmacy.PartnerUser,
        selectedPharmacy.PartnerPassword,
        RX_CARD_VIEW,
        utmParams
      );

      await this.setState({
        cardImage: fetchCouponResp.PDFUrl,
        urlCardType: false,
        selectedPharmacy: selectedPharmacy
      });
      await this.triggerGTMEvent(fetchCouponResp);
    } catch (err) {
      console.log(err.message);
    }
  }

  triggerGTMEvent(res) {
    if (!_.isEmpty(res)) {
      _.triggerGTMVirtualPageViewEvent({
        event: 'cardGenerated',
        authNumber: res.MemberNumberFull,
        grpNumber: res.GroupNumber,
        bin: res.BIN,
        pcn: res.PCN,
        pbm: this.state.data.internalPharmacy ? RXSENSE : NAVITUS
      });
    }
  }

  // remove remaining hardcoded values

  render() {
    let { pharmacyName, data } = this.state;
    const { t, i18n } = this.props;
    let isEs = _.isEqual(i18n.language, 'es');

    return _.isEqual(pharmacyName, undefined) ||
      _.isEqual(pharmacyName, 'invalid') ||
      (!API.ALLOW_NAVITUS && !data.internalPharmacy) ? (
      <NotFound />
    ) : (
      <main>
        <div className="homepage-new">
          <Helmet>
            <title>{data && data.metaTitle}</title>
            <meta name="description" content={data && data.metaDescription} />
            <script type="application/ld+json">
              {getStoreLdJson(pharmacyName)}
            </script>
            <link
              rel="canonical"
              href={`https://www.singlecare.com${this.props.location.pathname}`}
            />
            <link
              rel="alternate"
              href={`${PRESC_DESC_URL}/${this.props.match.params.storeType}`}
              hrefLang="en-us"
            />
            <link
              rel="alternate"
              href={`${PRESC_DESC_URL_ES}/${this.props.match.params.storeType}`}
              hrefLang="es-us"
            />
            <meta property="og:title" content={data && data.ogTitle} />
            <meta
              property="og:description"
              content={data && data.ogDescription}
            />
            <meta
              property="og:url"
              content={`https://www.singlecare.com${this.props.location.pathname}`}
            />
            <meta property="og:site_name" content="SingleCare" />
            <meta property="og:type" content="website" />
            <meta
              property="og:image"
              content={
                'https://www.singlecare.com/content/images/homepage/singleCareLogo.jpg'
              }
            />
          </Helmet>
          <div className="DiscountPageContainer">
            <div className="LandingSearch">
              <Breadcrumb>
                <span>
                  <a href={_.withLocale(i18n.language, '/')}>{t(`Home`)}</a>
                </span>
                <a
                  href={_.withLocale(
                    i18n.language,
                    `/prescription-discount-card`
                  )}
                >
                  {t('Prescription Discount Card')}
                </a>
                {i18n.language === 'en' ? (
                  <span>{`${pharmacyName} ${t('Card')}`}</span>
                ) : (
                  <span>
                    {`En ${pharmacyName} Pharmacy`}&nbsp;
                    {t('Card')}
                  </span>
                )}
              </Breadcrumb>
            </div>
            <div className="DiscountPageContent">
              <SkipTo>
                <h1>{data && data.h1}</h1>
              </SkipTo>
              <h2>{data && data.h2}</h2>
              <div className="CardMasheadDetails">
                <div className="card-masthead--image ">
                  <Image
                    imageUrl={this.state.cardImage}
                    imageAlt={
                      isEs
                        ? t('discount-card') + pharmacyName
                        : pharmacyName + t('discount-card')
                    }
                    imageClass="contactImage"
                    containerClass="imageContainer"
                    loaderClass="loaderImage"
                    loaderalt={t('Prescription card loading')}
                  />
                </div>
                {data && data.cardHighlights && (
                  <div className="card-masthead-description">
                    {documentToReactComponents(JSON.parse(data.cardHighlights))}
                  </div>
                )}
              </div>
              <RxCardSendCoupon
                selectedPrice={this.state.selectedPharmacy}
                isRxCard={true}
                isFromDiscountPage={true}
                isFromPhysicalModal={false}
                ispharmacySpecificPage={true}
              />
            </div>
            <div className="topDrugsSection">
              <h2 className="subTitle">
                {data && data.popularPrescriptionsSubhead}
              </h2>
              <TopDrugs
                drugsObj={{
                  drugs: data?.popularPrescriptions?.drugs
                }}
              />
              <div>
                <section className="drug-faqs">
                  <div className="faq-list">
                    <h2>{data && data.faqSubhead}</h2>
                    <div className="faq-art">
                      <div className="faq-art-b">
                        {data &&
                          data.faQs &&
                          documentToReactComponents(JSON.parse(data.faQs))}
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
            <div>
              <DiscountSavingsSection
                isSinglecare={false}
                pharmacyName={pharmacyName}
              />
              <div className="unlockPrescriptionContainer">
                <h2>{data && data.cardSelectorSubhead}</h2>
                <PharmacyList
                  cardSelectorPharmacies={data && data.cardSelectorPharmacies}
                />
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }
}

export default withTranslation()(DiscountPage);
